import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FileDrop } from "react-file-drop";
import { ToastContainer } from "react-toastify";
import { changeLibraryModal } from "../../../../../redux/actions/library";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { requestFileUpload } from "../../../../../redux/actions/library";
import { useDispatch, useSelector } from "react-redux";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { auth } from "../../../../../networking/firebase";
import { Popup } from "../../../../library/popup";
import { Label } from "../../../../library/label";
import "./style.scss";
import Text from "../../../../library/text";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.library.showModals.uploadModal
  );
  const companyId = useSelector(
    (state) => state.activeCompany.activeCompany.id
  );
  const loading = useSelector((state) => state.library.uploadFile.loading);
  const uploadProgress = useSelector(
    (state) => state.library.uploadFile.progress
  );

  const [newFile, setNewFile] = useState(null);
  const [_, setNewFileProgress] = useState(null);

  const [newFilePasswordOne, setNewFilePasswordOne] = useState("");
  const [newFilePasswordTwo, setNewFilePasswordTwo] = useState("");

  const [isNewFilePasswordProtected, setIsNewFilePasswordProtected] =
    useState(false);

  const handleClose = () => {
    dispatch(changeLibraryModal({ uploadModal: false }));
    resetUploadSettings();
  };

  const displayNewFileSize = (bytes) => {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  const handleFileDrop = (file, e) => {
    if (file && file[0] && file[0].size <= 100000000) {
      setNewFile(file[0]);
    } else {
      sendErrorNotification("Maks filstørrelse er 10MB.");
    }
  };

  const resetUploadSettings = () => {
    setNewFileProgress(0);
    setNewFile(undefined);
    setIsNewFilePasswordProtected(false);
    setNewFilePasswordOne("");
    setNewFilePasswordTwo("");
  };

  const clickUploadButton = () => {
    if (newFile) {
      if (newFilePasswordOne !== "" || newFilePasswordTwo !== "") {
        if (newFilePasswordOne === newFilePasswordTwo) {
          setNewFileProgress(0.01);
          dispatch(
            requestFileUpload({
              file: newFile,
              password: newFilePasswordOne,
              companyId: companyId,
              owner: auth.currentUser.uid,
            })
          );
        } else {
          sendErrorNotification("Passordene du oppga er ikke like.");
        }
      } else {
        setNewFileProgress(0.01);
        dispatch(
          requestFileUpload({
            file: newFile,
            password: newFilePasswordOne,
            companyId: companyId,
            owner: auth.currentUser.uid,
          })
        );
      }
    } else {
      sendErrorNotification("Du må velge en fil før du laster opp.");
    }
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Last opp fil"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Laster opp.." : "Last opp"}
          icon={
            loading ? (
              <i className="fas fa-circle-notch fa-spin"></i>
            ) : (
              <i className="fas fa-upload"></i>
            )
          }
          onClick={() => clickUploadButton()}
          type="button"
        />,
      ]}
    >
      <div className="upload-file-content-container">
        <div className="file-drop-container">
          <FileDrop onDrop={handleFileDrop}>
            {newFile ? (
              <div className="file-container">
                <h1 className="file-icon">
                  <i className="far fa-file-image"></i>
                </h1>
                <h3 className="file-name">{newFile.name}</h3>
                <p className="file-size">{displayNewFileSize(newFile.size)}</p>
                <div
                  className="progress"
                  style={{ display: uploadProgress > 0 ? "flex" : "none" }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: uploadProgress + "%" }}
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            ) : (
              <div className="no-file-container">
                <h3 className="upload-container-title">
                  Dra en fil hit for å laste opp.
                </h3>
                <Text align="center">
                  Du kan kun laste opp filer enkeltvis.
                </Text>
              </div>
            )}
          </FileDrop>
        </div>
        <div className="file-info-container">
          <Row>
            <Col>
              <h3 className="info-title">Innstillinger</h3>
              <Input
                type="checkbox"
                checked={isNewFilePasswordProtected ? true : false}
                onChange={(e) =>
                  setIsNewFilePasswordProtected(e.target.checked)
                }
                id="password"
                className="password-check"
                name="password"
                value="password"
              />
              <Label version={1} weight="bold">
                Passordbeskyttet (valgfritt)
              </Label>
            </Col>
          </Row>
          <Row
            className="password-row"
            style={{
              opacity: isNewFilePasswordProtected !== true ? "0.5" : "1.0",
            }}
          >
            <Col md={6} className="text-left">
              <Label version={1} weight="bold">
                Passord
              </Label>
              <Input
                onChange={(e) => setNewFilePasswordOne(e.target.value)}
                value={newFilePasswordOne}
                disabled={isNewFilePasswordProtected ? false : true}
                type="password"
                placeholder="Passord"
              />
            </Col>
            <Col md={6} className="text-left">
              <Label version={1} weight="bold">
                Gjenta passord
              </Label>
              <Input
                onChange={(e) => setNewFilePasswordTwo(e.target.value)}
                value={newFilePasswordTwo}
                disabled={isNewFilePasswordProtected ? false : true}
                type="password"
                placeholder="Passord"
              />
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
